import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Chip } from "@mui/material";
import { useTranslate } from "react-admin";

import { CRM_COLORS, formatCrmDateTime } from "../../lib/crm";

// A record Salesforce deleted, which the copy keeps and shows (NG-9669).
export const DeletedInSalesforceBadge = ({ deletedAt }: { deletedAt: string }) => {
  const translate = useTranslate();
  return (
    <Chip
      size="small"
      variant="outlined"
      data-testid="deleted-in-salesforce"
      icon={<DeleteOutlineIcon sx={{ fontSize: 14, "&&": { color: CRM_COLORS.textWeak } }} />}
      label={translate("crm.deletedInSalesforce")}
      title={translate("crm.deletedInSalesforceAt", { time: formatCrmDateTime(deletedAt) })}
      sx={{
        height: 20,
        ml: "6px",
        fontSize: "12px",
        fontWeight: 600,
        color: CRM_COLORS.textWeak,
        backgroundColor: CRM_COLORS.pathIncomplete,
        borderColor: CRM_COLORS.timelineLine,
        verticalAlign: "middle",
      }}
    />
  );
};
